import languages, { defaultLanguage } from "@/lib/data/languages";
import { LanguageKeyType } from "@/lib/main";

const VALID_LANGUAGE_KEYS: LanguageKeyType[] = ["en", "ar"];

const getStoredLanguage = () => {
  return localStorage.getItem("language");
};

const getDeviceLanguage = (): LanguageKeyType => {
  const userLanguage = navigator.language.split("-")[0];
  // * default to English if user's device language is not Arabic
  return (VALID_LANGUAGE_KEYS as string[]).includes(userLanguage)
    ? (userLanguage as LanguageKeyType)
    : defaultLanguage.key;
};

export const getInitialLanguageKey = (): LanguageKeyType => {
  const stored = getStoredLanguage();
  if (stored && (VALID_LANGUAGE_KEYS as string[]).includes(stored)) {
    return stored as LanguageKeyType;
  }
  return getDeviceLanguage();
};

export const getLanguageSettings = (languageKey: LanguageKeyType) => {
  const languageSettings = languages.find((item) => item.key === languageKey);
  return {
    htmlLanguage: languageSettings?.htmlLanguage,
    textDirection: languageSettings?.textDirection,
  };
};
